import { NavLink, Outlet } from 'react-router-dom';
import { Masthead } from '@/components/Masthead';
import styled from 'styled-components';
import { Constrain } from '@/components/Constrain';
import { Text } from '@/components/Text';
import OrganisationIcon from '@/icons/Organisation';
import AccountIcon from '@/icons/Account';

/** Port of the `_boundary.settings` layout (requireAuth → ProtectedRoute at the route). */
export function SettingsLayout() {
    return (
        <>
            <Masthead />

            <Constrain>
                <SettingsGrid>
                    <SettingsMenu>
                        <StyledNavLink to="/settings/user">
                            <AccountIcon fillColor="uNavy" />
                            <Text as="span" font="secondary">
                                User Settings
                            </Text>
                        </StyledNavLink>
                        <StyledNavLink to="/settings/organisation">
                            <OrganisationIcon fillColor="uNavy" />
                            <Text as="span" font="secondary">
                                Organisation Settings
                            </Text>
                        </StyledNavLink>
                    </SettingsMenu>
                    <div>
                        <Outlet />
                    </div>
                </SettingsGrid>
            </Constrain>
        </>
    );
}

const SettingsGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr 4fr;
    gap: 32px;
`;

const SettingsMenu = styled.nav`
    display: flex;
    flex-direction: column;
`;

const StyledNavLink = styled(NavLink)`
    display: flex;
    align-items: center;
    gap: 8px;
    flex-direction: row;
    text-decoration: none;
    padding: 8px;
    border-radius: 8px;

    svg {
        flex-shrink: 0;
        width: 24px;
    }

    &.active {
        background-color: ${({ theme }) => theme.colors.white};
        font-weight: bold;

        ${Text} {
            font-weight: bold;
        }
    }
`;
